import { ATTENTION_TIERS } from "@healthos/shared";
import { z } from "zod";
/**
 * AttentionEvent: the scarce resource HealthOS budgets per user per day.
 * See docs/HealthOS_Design_Doc.md section 5 and docs/HealthOS_Product_Plan.md section 4.
 *
 * The Harness gates every candidate delivery through an AttentionBudget check
 * before it ever reaches a surface. Each event is tier-classified so the UI
 * knows whether to render a quiet card, a timely nudge, or an important banner.
 */
export const AttentionTierSchema = z.enum(ATTENTION_TIERS);
export const AttentionEventSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().min(1),
    tier: AttentionTierSchema,
    surface: z.enum(["companion-web", "companion-mobile", "email", "push", "sms", "partner-embed"]),
    reason: z.string().max(280),
    evidence: z
        .array(z.object({
        signalId: z.string().uuid().optional(),
        kind: z.string().max(60),
        summary: z.string().max(240),
    }))
        .max(8)
        .default([]),
    proposedActionPlanId: z.string().uuid().optional(),
    scheduledFor: z.string().datetime(),
    expiresAt: z.string().datetime(),
    consumedAt: z.string().datetime().optional(),
    suppressedBy: z
        .enum(["quiet-hours", "daily-budget", "per-surface-cap", "crisis-override", "consent-revoked"])
        .optional(),
});
//# sourceMappingURL=attention.js.map